module.exports = __webpack_public_path__ + "img/icon-facebook.664a5d71.svg";